import deleteBackground from '@shoflo/studio-redux/actions/background/deleteBackground';
import deleteBanner from '@shoflo/studio-redux/actions/banner/deleteBanner';
import deleteOverlay from '@shoflo/studio-redux/actions/overlays/deleteOverlay';
import batchUpdateScenes from '@shoflo/studio-redux/actions/scene/utils/batchUpdateScenes';
import removeSourceFromScene from '@shoflo/studio-redux/actions/scene/utils/removeSourceFromScene';

import deleteSource from 'actions/Broadcast/sources/deleteSource';
import { withCurrentParams } from 'actions/utils';
import { filteredScenesForUpdate } from 'utils/broadcastSourceHelper';
import { BROADCAST_UPDATE_SCENE_DELETE_SOURCE_FROM_SCENE } from 'actions/Types';
import setProgram from 'actions/Broadcast/program/setProgram';

/**
 * Removes a source from a scene
 *
 * @param {string} sourceId
 * @param {Array} scenes
 * @param {Object} deleteParams - extra parameters
 */
const deleteSourceFromScene = (sourceId, scenes, deleteParams = {}) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const { isBackgroundSource, isOverlaySource, isBannerSource } =
        deleteParams;
      const { brandingSettings } = getState();

      const updatedScenes = removeSourceFromScene(
        scenes,
        sourceId,
        isBackgroundSource,
        brandingSettings?.fonts
      );

      const filteredScenes = filteredScenesForUpdate(updatedScenes);

      const action = {
        type: BROADCAST_UPDATE_SCENE_DELETE_SOURCE_FROM_SCENE,
        request: async apiClient => {
          const response = await batchUpdateScenes(filteredScenes, apiClient, {
            teamId,
            eventId,
            broadcastId
          });

          if (isBackgroundSource) {
            dispatch(deleteBackground(sourceId, { isBackgroundSource: true }));
          } else if (isOverlaySource) {
            dispatch(deleteOverlay(sourceId));
          } else if (isBannerSource) {
            dispatch(deleteBanner(sourceId, {}, setProgram));
          } else {
            dispatch(deleteSource(sourceId));
          }

          return { scenes: response.scenes };
        }
      };

      dispatch(action);
    }
  );
};

export default deleteSourceFromScene;
